import { render } from "./LbrxPhoneNumberInput.vue?vue&type=template&id=593920dc&scoped=true"
import script from "./LbrxPhoneNumberInput.vue?vue&type=script&lang=js"
export * from "./LbrxPhoneNumberInput.vue?vue&type=script&lang=js"

import "./LbrxPhoneNumberInput.vue?vue&type=style&index=0&id=593920dc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-593920dc"]])

export default __exports__